export default __webpack_public_path__ + "static/media/internet.4ba709f4.png";